// frontend/src/app/reducers/themeReducer.js
import { smallTheme } from '../app/themes/main/smallTheme'; // Düzeltildi
import { mainTheme } from '../app/themes/main/mediumTheme'; // Düzeltildi
import { largeTheme } from '../app/themes/main/largeTheme'; // Düzeltildi

const initialState = {
    currentTheme: mainTheme, // Varsayılan tema
};

const theme = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_THEME':
            return {
                ...state,
                currentTheme: action.payload,
            };
        default:
            return state;
    }
};

export default theme;
